/* Accessible progressive enhancement for the editorial navigation. */
(function () {
    var toggle = document.querySelector('.bh-menu-toggle');
    var navigation = document.querySelector('.bh-navigation');
    var menus = document.querySelectorAll('.bh-explore-menu');
    if (!toggle || !navigation) return;
    toggle.hidden = false;
    document.documentElement.classList.add('bh-js');
    function closeMenu(restoreFocus) {
        toggle.setAttribute('aria-expanded', 'false');
        navigation.classList.remove('is-open');
        menus.forEach(function (menu) { menu.open = false; });
        if (restoreFocus) toggle.focus();
    }
    toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        navigation.classList.toggle('is-open', open);
    });
    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var opened = Array.from(menus).find(function (menu) { return menu.open; });
        if (opened) {
            opened.open = false;
            opened.querySelector('summary').focus();
        } else if (toggle.getAttribute('aria-expanded') === 'true') {
            closeMenu(true);
        }
    });
    document.addEventListener('click', function (event) {
        menus.forEach(function (menu) { if (!menu.contains(event.target)) menu.open = false; });
        if (!event.target.closest('.bh-header')) closeMenu(false);
    });
    navigation.addEventListener('click', function (event) {
        if (event.target.closest('a')) closeMenu(false);
    });
    menus.forEach(function (menu) {
        menu.addEventListener('toggle', function () {
            if (menu.open) menus.forEach(function (other) { if (other !== menu) other.open = false; });
        });
    });
    window.matchMedia('(min-width: 801px)').addEventListener('change', function () {
        closeMenu(false);
    });
    document.querySelectorAll('.bh-nav-links > a').forEach(function (link) {
        if (new URL(link.href).pathname === window.location.pathname) link.setAttribute('aria-current', 'page');
    });
    document.querySelectorAll('.bh-map-figure').forEach(function (figure) {
        var caption = figure.querySelector('.bh-map-caption');
        var original = caption.textContent;
        figure.querySelectorAll('[data-map-label]').forEach(function (pin) {
            function show() { caption.textContent = pin.dataset.mapLabel; }
            function reset() { caption.textContent = original; }
            pin.addEventListener('mouseenter', show);
            pin.addEventListener('focus', show);
            pin.addEventListener('mouseleave', reset);
            pin.addEventListener('blur', reset);
        });
    });
})();
